import React from "react";
import styles from "./SHProducts.module.scss";

export const ProductCardSkeletonList = ({ count = 6 }) => (
  <div className={styles.card_list}>
    {Array.from({ length: count }).map((_, idx) => (
      <div key={idx} data-testid="skeleton-card" className={styles.skeleton_card}>
        <div className={styles.skeleton_image} />
        <div className={styles.skeleton_text}>
          <div className={styles.skeleton_line_lg} />
          <div className={styles.skeleton_line_sm} />
        </div>
      </div>
    ))}
  </div>
);
